import { useEffect, useRef, useState } from 'react';
import { sendLinkOtp, verifyLinkOtp } from '../Requests/Get_AuthAPI';
import './Component_Link_Otp_Popup.css';

interface Props {
  maskedEmail: string;
  onVerified: () => void;
  onCancel: () => void;
}

export default function Component_Link_Otp_Popup({ maskedEmail, onVerified, onCancel }: Props) {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    setError('');
    try {
      const r = await sendLinkOtp();
      if (!r.ok) setError(r.status === 429 ? 'Too many requests. Please wait a few minutes and try again.' : (r.message || 'Could not send the code. Please try again.'));
    } catch {
      setError('Could not send the code. Please try again.');
    }
    setBusy(false);
  };

  // Send the code as soon as the popup opens
const sentOnce = useRef(false);
  useEffect(() => {
    if (sentOnce.current) return;
    sentOnce.current = true;
    send();
  }, []);
  
  const verify = async () => {
    setBusy(true);
    setError('');
    try {
      const r = await verifyLinkOtp(otp);
      if (r.ok) { onVerified(); return; }
      setError(r.status === 429 ? 'Too many attempts. Please wait a few minutes and try again.' : (r.message || 'Invalid or expired code.'));    } catch {
      setError('Verification failed. Please try again.');
    }
    setBusy(false);
  };

  return (
    <div className="link-otp-overlay">
      <div className="link-otp-modal">
        <h3 className="link-otp-title">Verify your email</h3>
        <p className="link-otp-text">
          We sent a 6-digit code to {maskedEmail}. Enter it below to continue.
        </p>
        <input
          className="link-otp-input"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputMode="numeric"
          placeholder="Enter code"
        />
        {error && <p className="link-otp-error">{error}</p>}
        <div className="link-otp-actions">
          <button className="link-otp-btn link-otp-btn-secondary" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button className="link-otp-btn link-otp-btn-secondary" onClick={send} disabled={busy}>
            Resend
          </button>
          <button
            className="link-otp-btn link-otp-btn-primary"
            onClick={verify}
            disabled={busy || otp.length !== 6}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
}